import urls from "../../common/js/urls";


const ads_config = {
    all_ads: [],
    olx_ads: [],
    accounts: [],
    rareData: {
        categories: {url: urls.category, data: []},
        regions: {url: urls.regions, data: []},
        districts: {url: urls.districts, data: []},
    },
    CATEGORIES: [],
    all_regions: [],
    all_cities: [],
    all_districts: [],
    filteredAds: [],
    adsLoading: true,
    adsLoaded: false,
    all_bots: [],
    all_connections: [],
    dataToConnect: [],
    dataToDisconnect: [],
    dataToConnectBulk: [],
    dataToDisconnectBulk: [],
    emptyConnections: [],
    cityIdsToUpdate: [],
    drafts: [],
    draftsLoading: true,
    draftsError: '',
    plans: [],
    selectedPlanResults: null,
    selectedPlanItemHistory: null,
    draftImportReport: null,
    draftImportAttempt: null,
    selectedDraftIds: [],
    activeWorkspaceTab: 'olx-ads',
    planFilters: {
        status: 'all',
    },
    draftFilters: {
        categories: [],
        locations: [],
        readiness: 'all',
        archive: 'active',
        search: '',
        sort: '',
        limit: 50,
    },
    currencies_rates: {},
    currencies: {
        'UAH': 'грн.',
        'USD': '$',
        'EUR': '€',
        'PLN': 'zł',
        'RON': 'lei',
        'BGN': 'лв.',
        'KZT': 'тг.',
    }
};
let selectors = {
    accounts: '#accounts-select',
    botPresenceFilter: '#bot-presence-select',
    botIdsFilter: '#bot-id-select',
    categories: '#categories-select',
    locations: '#locations-select',
    newBotFilter: '#newBotFilter2',
    adsList: '#inventory-list',
    bulkContainer: '#bulk_container',
    workspaceRoot: '#ads-workspace',
    workspaceTabs: '.ads-workspace-tab',
    plannerSourceType: '#planner-source-type',
    plannerSlotSource: '#planner-slot-source',
    plannerDraftIds: '#planner-draft-ids',
    plannerAccountIds: '#planner-account-ids',
    plannerExistingAds: '#planner-existing-ads',
};


export {ads_config, selectors};
